import type { TradingInstruments } from '../types/tag-data.types';

/**
 * Trading instrument configuration constants
 * These will be replaced with dynamic data from the account in future phases
 */
export const TRADING_INSTRUMENTS: TradingInstruments = {
  FUTURES: { label: 'Futures', color: 'yellow' as const },
  FOREX: { label: 'Forex', color: 'purple' as const },
  STOCKS: { label: 'Stocks', color: 'blue' as const },
} as const;
